import React from 'react';
import { Link } from 'react-router-dom';
import { t } from 'i18n';

const NotFound = () => {
  return (
    <div className="min-h-[calc(100vh-200px)] flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-gray-300">404</h1>
        </div>
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">{t('notFound.title')}</h2>
          <p className="text-gray-600 mb-8">
            {t('notFound.body')}
          </p>
        </div>
        <div className="space-y-4">
          <Link
            to="/"
            className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-md transition-colors duration-200"
          >
            {t('notFound.goHome')}
          </Link>
          <div className="block">
            <Link
              to="/shop"
              className="text-blue-600 hover:text-blue-800 font-medium"
            >
              {t('notFound.browse')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;